conferenceClient.controller('canvasTouchHandlerCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'helperService',
    'logService',
    'contentService',
    function ($rootScope, $scope, $window, $timeout, helperService, logService, contentService) {
        var self = this;

        //Pinch-to-Zoom
        self.onVideoPinch = onVideoPinch;
        self.onVideoPinchStart = onVideoPinchStart;
        self.onVideoPinchEnd = onVideoPinchEnd;
        self.onVideoPinchCancel = onVideoPinchCancel;
        self.onVideoPan = onVideoPan;
        self.onVideoPanStart = onVideoPanStart;
        self.onVideoPanEnd = onVideoPanEnd;
        self.onVideoTap = onVideoTap;
        self.applyZoom = applyZoom;
        self.applyPanOffsetsWhileZooming = applyPanOffsetsWhileZooming;
        self.getPanOffsetsWhileZooming = getPanOffsetsWhileZooming;
        self.getPanConstraints = getPanConstraints;
        self.applyPanOffsets = applyPanOffsets;
        self.resetPanOffsets = resetPanOffsets;
        self.resetZoom = resetZoom;
        self.getCanvasData = getCanvasData;
        self.initIScroll = initIScroll;
        self.resetPanAndZoom = resetPanAndZoom;
        self.isVideoZoomed = isVideoZoomed;
        self.closeTabletSideBarIfOpen = closeTabletSideBarIfOpen;
        self.curPanX = 0;
        self.curPanY = 0;
        self.pinchStartX = 0;
        self.pinchStartY = 0;
        self.panUpdating = false;
        self.zoomUpdating = false;
        self.currentPinchDirection = null;
        self.currentPinchDirectionSwitched = false;
        self.isVideoCurrentlyZooming = false;
        self.isVideoCurrentlyPanning = false;
        self.iScrollObj = null;
        self.videoTapTimer = null;
        self.tapCount = 0;

        init();

        ////////////////////////

        function init() {
            if (helperService.isMobile()) {
                //Android uses iscroll for pinch-to-zoom
                //iOS uses pinch/pan event handlers in this ctrl
                if (helperService.getDeviceType() === 'Android') {
                    self.initIScroll();
                }

                $window.cordova.plugins.backgroundMode.on('activate', self.resetPanAndZoom);
                $window.cordova.plugins.backgroundMode.on('deactivate', self.resetPanAndZoom);

                $scope.$on('content-playing', onContentPlaying);
                $scope.$on('content-stopped', onContentStopped);
                $scope.$on('video-feed-count', onVideoFeedCountChange);
            }
        }

        function initIScroll() {
            //We don't currently reference iScrollObj anywhere in the code,
            //But it comes in handy for debugging purposes
            self.iScrollObj = new $window.IScroll('#conference', {
                zoom: true,
                mouseWheel: true,
                wheelAction: 'zoom',
                disablePointer: true,
                disableTouch: false,
                disableMouse: false,
                scrollX: true,
                scrollY: true,
                freeScroll: true
            });

            self.iScrollObj.on('zoomEnd', function () {
                helperService.isVideoZoomed = self.isVideoZoomed();
            });
        }

        //Helper Function
        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function applyZoom(scale) {
            var canvasData = self.getCanvasData();
            var newCanvasScalePercentage = canvasData.currentCanvasScalePercentage * scale;

            //These marge values are abritrary, and intentionally larger
            //than our zoom constraints.
            //On pinch-end event, constraints will be applied to shrink the feed,
            //which creates the 'bounce' effect.
            var minBounceMargin = 90;
            var maxBounceMargin = 360;
            if (newCanvasScalePercentage < minBounceMargin) {
                newCanvasScalePercentage = minBounceMargin;
            } else if (newCanvasScalePercentage > maxBounceMargin) {
                newCanvasScalePercentage = maxBounceMargin;
            }

            //Update height/width of canvas
            $window.$('#conference').css('width', newCanvasScalePercentage + '%');
            $window.$('#conference').css('height', newCanvasScalePercentage + '%');

            //Offset X & Y based on origin of pinch
            self.applyPanOffsetsWhileZooming();
        }

        //This function calculates the amount of X & Y to offset the canvas,
        //so when zooming, the center of the screen stays true to the origin of the pinch
        function getPanOffsetsWhileZooming() {
            var canvasData = self.getCanvasData();
            var curScale = canvasData.currentCanvasScalePercentage / 100;
            var panConstraints = self.getPanConstraints(false);

            //X calculations
            var pinchStartXWithScale = self.pinchStartX * curScale; //Starting x coordinate, based on percentage of original canvas
            var centerOfCanvasWidth = canvasData.currentCanvasWidth / 2; //Center x coordinate of zoomed canvas width
            var pinchXDistanceFromCenter = pinchStartXWithScale - centerOfCanvasWidth; //Starting x coordinate's distance from center (pixel based, zoomed canvas)
            var centerXOffset = panConstraints.right / 2; //X-Offset value that would pan the zoomed canvas to its center
            var pinchXOffset = centerXOffset - pinchXDistanceFromCenter; //X-Offset value to actually apply to the current canvas

            //Y calculations
            var pinchStartYWithScale = self.pinchStartY * curScale;
            var centerOfCanvasHeight = canvasData.currentCanvasHeight / 2;
            var pinchYDistanceFromCenter = pinchStartYWithScale - centerOfCanvasHeight;
            var centerYOffset = panConstraints.bottom / 2;
            var pinchYOffset = centerYOffset - pinchYDistanceFromCenter;

            return {
                x: pinchXOffset,
                y: pinchYOffset
            };
        }

        //This event listener doesn't track first and last pinch events that well,
        //which is why we have separate listeners for pinchStart and pinchEnd
        function onVideoPinch(ev) {
            if (self.zoomUpdating && (ev.additionalEvent === 'pinchin' || ev.additionalEvent === 'pinchout')) {
                return;
            }

            //This gate allows enough time to refresh the feed before
            //updating the values of the current zoom / position.
            //Without it, the zoom/panning will experience skipping/jumping
            self.zoomUpdating = true;

            //For Pinch-Out, ev.scale incremements from 1 and up (depending on pinch velocity)
            //With fast pinch-outs, highest scale I've seen was around 5-6
            //For Pinch-In, ev.scale decrements from 0.9 to 0 (depending on pinch velocity)
            //
            //When pinch direction switches without letting go,
            //the scale is much smaller for some reason...
            //We add an arbitrary exponential increase to offset that
            var scale = ev.scale;

            if (!self.currentPinchDirection) {
                self.currentPinchDirection = ev.additionalEvent;
            } else if (self.currentPinchDirection !== ev.additionalEvent) {
                self.currentPinchDirectionSwitched = true;
                self.currentPinchDirection = ev.additionalEvent;
            }

            if (self.currentPinchDirectionSwitched) {
                scale = Math.pow(scale, 4);
            }

            self.applyZoom(scale);

            //Allows enough time for the feed refresh
            $timeout(function () {
                self.zoomUpdating = false;
            }, 50);
        }

        function onVideoPinchStart(ev) {
            //This flag prevents pan events from changing X&Y's while zooming
            self.isVideoCurrentlyZooming = true;
            self.pinchStartedWhileAleadyZoomed = self.isVideoZoomed();

            if (ev.center) {
                //Save origin X & Y of pinch event to calculate
                //Which part of the feed to center on during zooming in/out
                self.pinchStartX = ev.center.x;
                self.pinchStartY = ev.center.y;
            }

            self.closeTabletSideBarIfOpen();
        }

        function onVideoPinchEnd() {
            //Apply constraints to zooming in/out
            var currentCanvasData = self.getCanvasData();

            if (currentCanvasData.currentCanvasScalePercentage < 100) {
                $window.$('#conference').css('width', '100%');
                $window.$('#conference').css('height', '100%');
            } else if (currentCanvasData.currentCanvasScalePercentage > 300) {
                $window.$('#conference').css('width', '300%');
                $window.$('#conference').css('height', '300%');
            }

            var newCanvasData = self.getCanvasData();
            if (newCanvasData.currentCanvasScalePercentage === 100) {
                self.resetPanOffsets();
            } else {
                self.applyPanOffsetsWhileZooming();
            }

            $timeout(function () {
                self.isVideoCurrentlyZooming = false;
                self.currentPinchDirection = null;
                self.currentPinchDirectionSwitched = false;
                self.pinchStartedWhileAleadyZoomed = false;
                helperService.isVideoZoomed = self.isVideoZoomed();
            }, 50);
        }

        function onVideoPinchCancel() {
            //On cancel, we want to trigger the same flow as pinch-end
            self.onVideoPinchEnd();
        }

        function applyPanOffsetsWhileZooming() {
            //Get position of zoom (based on pinch X & Y origin)`
            var panOffsets;

            if (!self.pinchStartedWhileAleadyZoomed) {
                panOffsets = self.getPanOffsetsWhileZooming();
            } else {
                var curPosition = $window.$('#conference').position();
                panOffsets = {
                    x: curPosition.left,
                    y: curPosition.top
                };
            }

            self.applyPanOffsets(panOffsets, false);

            //Save current X & Y coordinates
            self.curPanX = panOffsets.x;
            self.curPanY = panOffsets.y;
        }

        function onVideoPanStart() {
            self.isVideoCurrentlyPanning = true;
        }

        function onVideoPanEnd() {
            if (!self.isVideoZoomed()) {
                return;
            }

            //Set new constraints without the 'allowed margin'
            var position = $window.$('#conference').position();
            var curOffsets = {
                x: position.left,
                y: position.top
            };

            self.applyPanOffsets(curOffsets, false);

            //Save current X & Y coordinates
            self.curPanX = curOffsets.x;
            self.curPanY = curOffsets.y;

            $timeout(function () {
                self.isVideoCurrentlyPanning = false;
            }, 50);
        }

        function onVideoPan(ev) {
            if (
                self.isVideoZoomed() &&
                !self.panUpdating &&
                ev.additionalEvent &&
                !self.isVideoCurrentlyZooming &&
                self.isVideoCurrentlyPanning
            ) {
                //This gate allows enough time to refresh the feed before
                //updating the values of the current zoom / position.
                //Without it, the zoom/panning will experience skipping/jumping
                self.panUpdating = true;

                var newPanOffsets = {
                    x: ev.deltaX + self.curPanX,
                    y: ev.deltaY + self.curPanY
                };

                self.applyPanOffsets(newPanOffsets, true);

                $timeout(function () {
                    self.panUpdating = false;
                }, 50);
            }
        }

        function onVideoTap(e) {
            self.tapCount++;

            if (!self.videoTapTimer) {
                self.videoTapTimer = $timeout(function () {
                    self.tapCount = 0;
                    self.videoTapTimer = null;
                }, 500);
            } else {
                if (self.tapCount === 2) {
                    self.resetPanAndZoom();
                }
            }
        }

        function getPanConstraints(withMargin) {
            var canvasData = self.getCanvasData();

            //withMargin param allows a 'bounce' effect
            var allowedMargin = withMargin ? 50 : 0;

            var leftConstraint = allowedMargin;
            var topConstraint = allowedMargin;
            var rightConstraint = (canvasData.currentCanvasWidth - canvasData.originalCanvasWidth + allowedMargin) * -1;
            var bottomConstraint =
                (canvasData.currentCanvasHeight - canvasData.originalCanvasHeight + allowedMargin) * -1;

            return {
                left: leftConstraint,
                top: topConstraint,
                right: rightConstraint,
                bottom: bottomConstraint
            };
        }

        function applyPanOffsets(offsets, withMargin) {
            //Apply constraints
            var constraints = self.getPanConstraints(withMargin);

            if (offsets.x > constraints.left) {
                offsets.x = constraints.left;
            }

            if (offsets.x < constraints.right) {
                offsets.x = constraints.right;
            }

            if (offsets.y > constraints.top) {
                offsets.y = constraints.top;
            }

            if (offsets.y < constraints.bottom) {
                offsets.y = constraints.bottom;
            }

            $window.$('#conference').css('transform', 'translate(' + offsets.x + 'px,' + offsets.y + 'px)');
            $window.cordova.plugins.iosrtc.refreshVideos();
        }

        function resetPanOffsets() {
            $window.$('#conference').css('transform', 'translate(0px,0px)');
            $window.cordova.plugins.iosrtc.refreshVideos();
        }

        function resetZoom() {
            $window.$('#conference').css('width', '100%');
            $window.$('#conference').css('height', '100%');
            $window.cordova.plugins.iosrtc.refreshVideos();
            helperService.isVideoZoomed = false;
        }

        //Helper function for zoom/panning calculations
        function getCanvasData() {
            var meetingContentID = helperService.isTablet() ? '#meetingContent' : '#mobileMeetingContent';
            var originalCanvasWidth = $window.$(meetingContentID).outerWidth();
            var originalCanvasHeight = $window.$(meetingContentID).outerHeight();

            var currentCanvasWidth = $window.$('#conference').outerWidth();
            var currentCanvasHeight = $window.$('#conference').outerHeight();

            //Height and Width should use same scale percentage
            var currentCanvasScalePercentage = (currentCanvasWidth / originalCanvasWidth) * 100;

            return {
                originalCanvasWidth: originalCanvasWidth,
                originalCanvasHeight: originalCanvasHeight,
                currentCanvasWidth: currentCanvasWidth,
                currentCanvasHeight: currentCanvasHeight,
                currentCanvasScalePercentage: currentCanvasScalePercentage
            };
        }

        function onContentPlaying() {
            self.resetPanAndZoom();
        }

        function onContentStopped() {
            self.resetPanAndZoom();
        }

        function resetPanAndZoom() {
            if (self.isVideoZoomed()) {
                var devicePlatform = helperService.getDevicePlatform();

                if (devicePlatform === 'iOS') {
                    self.resetPanOffsets();
                    self.resetZoom();
                } else if (devicePlatform === 'Android') {
                    //Sets scale to 1, and x/y coords to 0
                    self.iScrollObj.zoom(1, 0, 0);
                    helperService.isVideoZoomed = false;
                }
            }
        }

        function isVideoZoomed() {
            var conferenceWidthStyleAttr;

            try {
                conferenceWidthStyleAttr = $window.$('#conference')[0].style.width;
            } catch (e) {}

            return conferenceWidthStyleAttr !== undefined && conferenceWidthStyleAttr !== '100%';
        }

        function onVideoFeedCountChange(e, count) {
            //Reset if all webcams become hidden (and no content is playing)
            if (count === 0 && !contentService.isContentPlaying()) {
                self.resetPanAndZoom();
            }
        }

        function closeTabletSideBarIfOpen() {
            var sideBarElement = angular.element('#sidebar-left')[0];

            if (helperService.isTablet() && sideBarElement.className.indexOf('toggled') >= 0) {
                var sideBarElementComputedWidth = $window
                    .getComputedStyle(sideBarElement, null)
                    .getPropertyValue('width');
                var width = sideBarElementComputedWidth ? sideBarElementComputedWidth : '300px';
                sideBarElement.style.left = '-' + width;

                $rootScope.$broadcast('toggle-left-sidebar', 'closed');
            }
        }
    }
]);
